import { useContext, useEffect, useState } from "react";
import apiRequest from "../../../../services/apiRequest";
import { NotificationsContext } from "../../../Notifications";

export function useRoleNames() {
  const { push } = useContext(NotificationsContext);
  const [roleNames, setRoleNames] = useState(null);

  useEffect(() => {
    let closed = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get("/roles");

        if (typeof data !== "object") {
          throw new Error("not object");
        }

        if (!closed) {
          setRoleNames(data);
        }
      } catch (error) {
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    fetchData();

    return () => {
      closed = true;
    };
  }, [push]);

  return roleNames;
}

export function useGroupNames() {
  const { push } = useContext(NotificationsContext);
  const [groupNames, setGroupNames] = useState(null);

  useEffect(() => {
    let closed = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get("/groups");

        if (typeof data !== "object") {
          throw new Error("not object");
        }

        if (!closed) {
          setGroupNames(data);
        }
      } catch (error) {
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    fetchData();

    return () => {
      closed = true;
    };
  }, [push]);

  return groupNames;
}
